import { connect } from 'react-redux';
import Controls from 'components/map/controls/Controls';
import { fitBounds } from '../modules/map';
import { selectAreFeaturesEmpty } from '../modules/geojson';

export default connect(
  state => ({
    areFeaturesEmpty: selectAreFeaturesEmpty(state),
  }),
  { zoomToFullExtent: fitBounds },
)(Controls);
